/* global MR */

const state = {
  notifications: [],
  notificationId: 0
};

export const getters = {};

export const actions = {
  notifySuccess({ dispatch }, msg) {
    var payload = {
      class: 'success',
      message: msg
    };

    if (!payload.message) {
      payload.message = `Success!`;
    }

    dispatch('notify', payload);
  },

  notifyError({ dispatch }, msg) {
    var payload = {
      class: 'error',
      message: msg
    };

    if (!payload.message) {
      payload.message = `Something went wrong and your action could not be completed. Please review your information or call us at ${MR.config.contactPhone}`;
    }

    dispatch('notify', payload);
  },

  notifyInfo({ dispatch }, msg) {
    var payload = {
      class: 'info',
      message: msg
    };

    dispatch('notify', payload);
  },

  notifyWarn({ dispatch }, msg) {
    var payload = {
      class: 'warn',
      message: msg
    };

    dispatch('notify', payload);
  },

  notify({ commit, state }, notification) {
    var duplicateMessage = false;

    state.notifications.forEach(notif => {
      if (notif.message === notification.message) {
        duplicateMessage = true;
      }
    });

    if (duplicateMessage) {
      return;
    }

    notification.id = state.notificationId;

    commit('addNotification', notification);
    commit('increaseId');
    setTimeout(() => commit('popNotification'), notification.time);
  },

  removeNotification({ commit, state }, id) {
    var noteIdx = 0;
    for (noteIdx = 0; noteIdx < state.notifications.length; noteIdx++) {
      if (state.notifications[noteIdx].id == id) {
        break;
      }
    }

    if (noteIdx < state.notifications.length) {
      commit('removeByIndex', noteIdx);
    }
  }
};

export const mutations = {
  addNotification: (state, notification) => {
    if (!notification.time) {
      notification.time = 6000;
    }

    if (!notification.class) {
      notification.class = 'warn';
    }

    state.notifications.unshift(notification);
  },

  popNotification: state => state.notifications.pop(),
  increaseId: state => state.notificationId++,

  removeByIndex: (state, idx) => {
    state.notifications.splice(idx, 1);
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
